<template>
  <div>
    <table class="mt-3">
      <tr>
        <th colspan="3" class="py-2">
          <div class="d-flex" style="gap: 12px">
            <h5>Deal Owner</h5>
              <h5 v-if="canEditDealOwner">
                <span class="link" @click="openModal"
                  ><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i
                ></span>
              </h5>
          </div>
        </th>
      </tr>
      <tr>
        <td width="30%">Name</td>
        <td width="10%">&emsp;:&emsp;</td>
        <td width="60%" v-if="dealOwner.employeeName">
          {{ dealOwner.employeeName }}
        </td>
        <td width="60%" v-else>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </td>
      </tr>
    </table>
    <div class="modal fade" id="modalEditDealOwner" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Change Deal Owner</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex align-items-center" style="gap: 12px">
              <label style="width: 40%"> Name </label>
              <label class="ol-titik2">:</label>
              <multiselect
                v-model="dealOwnerValue"
                :options="employeeList"
                label="employeeName"
                track-by="employeeName"
                :allow-empty="false"
                deselect-label="Can't remove this value"
                placeholder="Select Deal Owner"
              ></multiselect>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="dealOwnerValue.id === dealOwner.id"
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitDealOwnerChange"
              v-if="!isLoading"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else-if="isLoading"
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { permissionMixin } from "@/components/Permissions";
import swal from "sweetalert";

export default {
  name: "DealOwnerSection",
  components: {
    Multiselect,
  },
  mixins: [permissionMixin],
  props: {
    dealOwner: {
      type: Object,
      default: () => ({
        employeeName: "",
        id: 0,
      }),
    },
    employeeList: {
      type: Array,
      default: () => [],
    },
    orderStatus: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      dealOwnerValue: {
        employeeName: "",
        id: 0,
      },
      isLoading: false,
    };
  },
  computed: {
    canEditDealOwner() {
      if (this.orderStatus < 3) {
        return true;
      }
      return this.hasPermission({
        requiredPermissions: ["2.12"],
      });
    },
  },
  methods: {
    openModal() {
      $("#modalEditDealOwner").modal("show");
    },
    async submitDealOwnerChange() {
      this.isLoading = true;
      try {
        const sentData = {
          orderId: Number(this.$route.params.orderId),
          dealId: this.dealOwnerValue.id,
        };
        const response = await this.$http.post(
          process.env.UPDATE_DEAL_OWNER,
          sentData,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data && response.data.status === 200) {
          $("#modalEditDealOwner").modal("hide");
          await swal("Success", "Deal owner updated successfully.", "success");
          this.$emit("deal-owner-updated");
          return;
        }
        swal(
          "Error",
          response.data.message || "Failed to update deal owner.",
          "error"
        );
      } catch (error) {
        swal(
          "Error",
          "Failed to update deal owner. Please try again.",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    dealOwner: {
      immediate: true,
      handler(newVal) {
        this.dealOwnerValue = { ...newVal };
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Order/CustomComponent/DealOwnerSection.vue